import { usewpdataSelectors } from 'lib/wpdataState/selectors';
import s from './CtaSection.module.scss';
import { useEffect, useState } from 'react';
import ShippingIcon from '../Icons/ShippingIcon';
import { Amex } from 'components/SharedIcons/CreditCards/Amex';
import { DinersClub } from 'components/SharedIcons/CreditCards/DinersClub';
import { Discover } from 'components/SharedIcons/CreditCards/Discover';
import { Mastercard } from 'components/SharedIcons/CreditCards/Mastercard';
import { PayPal } from 'components/SharedIcons/CreditCards/Paypal';
import { Visa } from 'components/SharedIcons/CreditCards/Visa';
import { readCookie, writeCookie } from '../../../utils/helpers';

const COOKIE_KEY = 'shipping_timer';
const COOLDOWN_MS = 24 * 60 * 60 * 1000; // 24h

const CtaSection = () => {
  const { hero, Theme } = usewpdataSelectors();
  const timerMinutes = Number(Theme?.timer) || 30;
  const initialTime = Math.round(timerMinutes * 60);

  const [timeLeft, setTimeLeft] = useState(() => {
    const cookie = readCookie(COOKIE_KEY);
    const now = Date.now();
    if (cookie && cookie.endAt && cookie.cooldownExpires > now) {
      return Math.max(0, Math.floor((cookie.endAt - now) / 1000));
    }
    return initialTime;
  });

  useEffect(() => {
    const now = Date.now();
    let cookie = readCookie(COOKIE_KEY);
    let endAt, cooldownExpires;
    if (cookie && cookie.endAt && cookie.cooldownExpires > now) {
      endAt = cookie.endAt;
      cooldownExpires = cookie.cooldownExpires;
    } else {
      endAt = now + initialTime * 1000;
      cooldownExpires = now + COOLDOWN_MS;
      writeCookie(COOKIE_KEY, { endAt, cooldownExpires }, COOLDOWN_MS / 1000);
    }

    const intervalId = setInterval(() => {
      setTimeLeft((prev) => {
        const next = Math.max(prev - 1, 0);
        return next;
      });
    }, 1000);

    return () => clearInterval(intervalId);
  }, [initialTime]);

  const minutes = Math.floor((timeLeft % 3600) / 60)
    .toString()
    .padStart(2, '0');
  const seconds = (timeLeft % 60).toString().padStart(2, '0');

  return (
    <div className={s.ctaSection}>
      {timeLeft > 0 && (
        <p className={s.timer} style={{ color: hero.styles.textColorSecondary }}>
          <ShippingIcon fill={hero.styles.shippingTextColor} />
          {hero?.shopWithin}{' '}
          <strong style={{ color: hero.styles.shippingTextColor }}>
            {minutes}:{seconds}
          </strong>{' '}
          {hero?.shopWihinTwo}
        </p>
      )}
      <div className={s.creditCards}>
        <PayPal />
        <Visa />
        <Mastercard />
        <Amex />
        <DinersClub />
        <Discover />
      </div>
    </div>
  );
};

export default CtaSection;
